import React from 'react';
import PrivacyContainer from '../../containers/privasi/PrivacyContainer';

const Privacy = () => (
  <PrivacyContainer />
);

export default Privacy;
